import { CompanyService } from "../services/company.service";

export interface CompanyDto {
  name: string;
  domain?: string;
  logo_url?: string;
  geo_coords?: string;
  address?: string;
  town_district?: string;
  distance?: number;
  website?: string;
  phone?: string;
  email?: string;
  keywords?: {
      keyword?: string;
      type?: string;
    }[];
}
export interface Company {
  name: string;
  domain?: string;
  logoUrl?: string;
  geo?: string;
  address?: string;
  town?: string;
  distance?: number;
  website?: string;
  phone?: string;
  email?: string;
  keywords?: {
      keyword?: string;
      type?: string;
    }[];
}

export class CompanyMapper {
  static fromCompanyDto(dto: CompanyDto): Company {
    const company: Company = {
      name: dto.name,
      domain: dto.domain,
      logoUrl: CompanyService.urlCompanyImage(dto.logo_url),
      geo: dto.geo_coords,
      address: dto.address,
      town: dto.town_district,
      distance: dto.distance,
      website: dto.website,
      phone: dto.phone,
      email: dto.email,
      keywords: dto.keywords
    };
    return company;
  }

  static toCompanyDto(data: Company): CompanyDto {
    const dto: CompanyDto = {
      name: data.name,
      domain: data.domain,
      logo_url: data.logoUrl,
      geo_coords: data.geo,
      address: data.address,
      town_district: data.town,
      distance: data.distance,
      website: data.website,
      phone: data.phone,
      email: data.email,
      keywords: data.keywords
    };
    return dto;
  }
}
